<template>
  <article class="al-notification_empty_state">
    <h5>No {{ name }} yet</h5>
    <p class="p">
      When your team start working you <br />
      will see the {{ name }} here.
    </p>
  </article>
</template>

<script>
/**
 * Component to show a placeholder for cases when there is not notifications.
 * @displayName notification-empty-state
 */

export default {
  props: {
    /**
     * Type of notitication.
     */
    name: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
// + Empty State

.al-notification_empty_state {
  display: flex;
  flex-flow: column;

  h5 {
    color: color(black, lighten, 2);
    font-size: font-size(base);
    font-weight: bold;
    text-align: center;
  }

  p.p {
    color: color(black, lighten, 3);
    font-size: font-size(base);
    text-align: center;
  }
}
</style>
